(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  function init_accordion() {
    let accordion_btn = document.querySelectorAll('.accordion-btn');

    if (typeof accordion_btn === "undefined" || accordion_btn === null) {
      return;
    }

    accordion_btn.forEach(btn => {
      if (btn.hasAttribute("data-product-option-id")) {

        function handleHashChange(event) {
          event.preventDefault();
          const buttonTop = btn.getBoundingClientRect();
          const offsetTop = buttonTop.top + window.scrollY;

          window.scrollTo({
            top: offsetTop - 40,
            behavior: 'smooth'
          });
        }

        window.addEventListener('hashchange', handleHashChange);

        // handleHashChange(new Event('hashchange'));

        function handleIntersection(entries, observer) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              toggle_accordion(entry.target);

              observer.unobserve(entry.target);
            }
          });
        }


        const observer = new IntersectionObserver(handleIntersection, {
          root: null,
          threshold: 0.5
        });

        observer.observe(btn);
      }

      btn.addEventListener("click", function(e) {
        toggle_accordion(this);
      });
    });
  }

  function toggle_accordion(btn) {
    let btn_panel_selector = btn.getAttribute('aria-controls');
    let btn_panel = document.getElementById(btn_panel_selector);
    let btn_panel_content = btn_panel.querySelector('.content-wrapper');

    let is_expanded = btn.getAttribute('aria-expanded');
    let btn_icon = btn.querySelector('.accordion-icon-top');

    if (is_expanded === 'true') {
      hide_accordion();
    } else {
      show_accordion();
    }

    function show_accordion() {
      btn_icon.classList.replace('rotate-90', 'rotate-180');

      btn.setAttribute('aria-expanded', 'true');

      btn_panel.removeAttribute("hidden");
      btn_panel.classList.replace('h-0', 'h-auto');

      btn_panel_content.classList.replace('opacity-0', 'opacity-100');
    }

    function hide_accordion() {
      btn_icon.classList.replace('rotate-180', 'rotate-90');

      btn.setAttribute('aria-expanded', 'false');

      btn_panel.setAttribute("hidden", "");
      btn_panel.classList.replace('h-auto', 'h-0');

      btn_panel_content.classList.replace('opacity-100', 'opacity-0');
    }
  }

  init_accordion();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  function init_product_tooltip() {
    let tooltip = document.getElementById('zipper-customizer-tooltip');
    let tooltip_trigger = document.querySelector('.zs-tooltip');

    if (
      typeof tooltip === 'undefined' ||
      tooltip === null ||
      typeof tooltip_trigger === 'undefined' ||
      tooltip_trigger === null
    ) {
      return;
    }

    // click on tooltip trigger
    ['mousedown', 'focus', 'blur'].forEach(function (event_type) {
      tooltip_trigger.addEventListener(event_type, function (e) {
        if (event_type === 'blur') {
          hide_tooltip();
          return;
        }

        e.preventDefault();

        if (tooltip.classList.contains('hidden')) {
          show_tooltip();
        } else {
          hide_tooltip();
        }
      });
    });

    // Click outside of tooltip
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.zs-tooltip') && document.body.classList.contains('tooltip-activated')) {
        return;
      }

      hide_tooltip();
    });

    function show_tooltip() {
      document.body.classList.add('tooltip-activated');
      tooltip.classList.replace('hidden', 'flex');
    }

    function hide_tooltip() {
      if (document.body.classList.contains('tooltip-activated')) {
        document.body.classList.remove('tooltip-activated');
      }
      tooltip.classList.replace('flex', 'hidden');
    }
  }
  init_product_tooltip();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-items"]) return;
  try {
    
 const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);

        const url = entry.target.dataset.url;

        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              entry.target.innerHTML = recommendations.innerHTML;

              // if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
    });
  };

  const productRecommendationsSections = document.querySelectorAll('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  productRecommendationsSections.forEach(section => {
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();
})();
